import { render, staticRenderFns } from "./CreateChannelDialog.vue?vue&type=template&id=1f9ddf51&scoped=true&lang=pug&"
import script from "./CreateChannelDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateChannelDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ddf51",
  null
  
)

export default component.exports